import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingSeparatedItem extends FirebaseModel {
    static entity = 'billingSeparatedItems';
    static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('separated_items');
    static fields(){
        return {
            name: this.attr(null),
            quick_books_name: this.attr(null),
            is_customer: this.attr(null),
            sample_category_uuid: this.attr(null),
            priority: this.attr(null),
            has_tests: this.attr(null),
            has_flags: this.attr(null),
            is_qa_only: this.attr(false),
            price: this.attr(null),
            ...super.fields()
        }
    }
}
